import React from "react"
import { Grid, Typography } from "@material-ui/core"
import { Select } from "@/popups/components/Select"
import { SelectRounded } from "@/popups/components/SelectRounded"
import useStyles from "@/popups/templates/MultiQuestionSurvey/styles"

const RATING_OPTIONS = [
	{ value: "excelente", label: "Excelente" },
	{ value: "bom", label: "Bom" },
	{ value: "regular", label: "Regular" },
	{ value: "ruim", label: "Ruim" }
]

const FEATURE_OPTIONS = [
	{ value: "atendimento", label: "Atendimento ao cliente" },
	{ value: "automacao", label: "Automação de mensagens" },
	{ value: "relatorios", label: "Relatórios e métricas" },
	{ value: "integracao", label: "Integrações" }
]

export type MultiQuestionSurveyValue = {
	q1: string[]
	q2: string
	q3: string
}

export type MultiQuestionSurveyProps = {
	value: MultiQuestionSurveyValue
	onChange: (value: MultiQuestionSurveyValue) => void
	title?: string
}

export const MultiQuestionSurvey: React.FC<MultiQuestionSurveyProps> = ({
	value,
	onChange
}) => {
	const classes = useStyles()

	return (
		<Grid container direction="column" spacing={3}>
			<Grid item>
				<Typography className={classes.questionLabel}>
					1. Como você avalia nossa plataforma?
				</Typography>
				<SelectRounded
					multiple
					options={RATING_OPTIONS}
					value={value.q1}
					onChange={(q1) => onChange({ ...value, q1 })}
				/>
			</Grid>

			<Grid item>
				<Typography className={classes.questionLabel}>
					2. Qual funcionalidade você mais utiliza?
				</Typography>
				<Select
					options={FEATURE_OPTIONS}
					value={value.q2}
					onChange={(q2) => onChange({ ...value, q2 })}
					placeholder="Selecione uma opção"
				/>
			</Grid>
		</Grid>
	)
}
